import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { NavLink } from "react-router-dom";
import { LBtn } from "../../../common/components/LBtn";
import { LButtonGroup } from "../../../common/components/LButtonGroup";
import { useState } from "react";
import { LWordMatch } from "../../../common/components/LWordMatch";
import { concatenateBlobs } from "../../../common/helpers/blobHelper";
import { ResultType, useSpeechToText } from "../../../utils/stt/useSpeechToText";
import { LMic } from "@components/LMic";

export const PoCLading = (): JSX.Element => {
    const [show2, setShow2] = useState(false);

    const handerOnStartSpeaking = (): void => {
        console.log("sound on");
    };

    const handlerOnStoppedSpeaking = (): void => {
        console.log("sound off");
    };

    const handleOnPlay = async (): Promise<void> => {
        const _results = [...results] as ResultType[];
        const blobs = _results.map((x) => x.speechBlob) as Blob[];

        // TODO: use this blob to send to API
        const oneBlob = await concatenateBlobs(blobs);

        const url = URL.createObjectURL(oneBlob);
        const audio = new Audio(url);

        void audio.play();
    };

    const { error, interimResult, isRecording, results, startSpeechToText, stopSpeechToText, recordingVolume } =
        useSpeechToText({
            continuous: true,
            fullAudio: true,
            crossBrowser: true,
            useOnlyGoogleCloud: true,
            googleApiKey: "AIzaSyARnh3MRMEIGIG0q0pMlTdrN_fpwtkDRrE",
            googleCloudRecognitionConfig: {
                maxAlternatives: 3,
                enableAutomaticPunctuation: false
            },
            azureApiKey: "",
            azureRegion: "",
            useLegacyResults: false,
            timeout: 60000,
            onStartSpeaking: handerOnStartSpeaking,
            onStoppedSpeaking: handlerOnStoppedSpeaking
        });

    if (error) {
        return (
            <div>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="hero is-fullheight">
            <div className="hero-head">
                <nav className="navbar">
                    <div className="navbar-brand">
                        <div className="navbar-item">
                            <NavLink to="/">
                                <FontAwesomeIcon icon={solid("arrow-right-from-bracket")} />
                            </NavLink>
                        </div>
                    </div>
                </nav>
            </div>
            <div className="hero-body">
                <div className="container has-text-centered">
                    <div className="columns">
                        <div className="column">
                            <LButtonGroup extraSpacing={true}>
                                <LBtn
                                    onClick={async () => {
                                        void startSpeechToText();
                                    }}
                                >
                                    Start
                                </LBtn>
                                <LBtn
                                    onClick={() => {
                                        void stopSpeechToText();
                                    }}
                                >
                                    Stop
                                </LBtn>
                                <LBtn onClick={handleOnPlay}>Play</LBtn>
                            </LButtonGroup>
                            <LMic showRec={isRecording} volume={recordingVolume} />
                            {/* <LMicrophone isSpeaking={isSpeaking} isRecording={isRecording} /> */}
                            <ul>
                                {results.map((result) => (
                                    <li key={result.confidence}>{result.transcript}</li>
                                ))}
                                {interimResult && <li>{interimResult}</li>}
                            </ul>
                        </div>
                        <div className="column">
                            <LBtn onClick={() => setShow2(true)}>Show second PoC</LBtn>
                            {show2 && (
                                <div>
                                    <div>Say the word ORANGE</div>
                                    <LWordMatch
                                        word="orange"
                                        silentTime={5}
                                        onSilentTimeout={() => alert("Come on! you can say the word!")}
                                        onMatch={(result) => {
                                            // result will contains the audio
                                            console.log(result);
                                            alert("You did it!!");
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
